import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c52e98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "global-modal" }
const _hoisted_2 = {
  tabindex: "-1",
  class: "overlay"
}
const _hoisted_3 = { class: "global-modal-container" }
const _hoisted_4 = { class: "return" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 戻る ")
const _hoisted_6 = { class: "scoreboard-modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "試合を開始しますか？", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 前半キックオフ ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "global-return-link",
            to: {
              name: 'seasonGameDetail',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
              query: { group: _ctx.game.group_id } }
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("button", {
            type: "button",
            class: "startButton",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickStartButton(1, 'start')))
          }, _hoisted_10)
        ])
      ])
    ])
  ]))
}